module.exports = __webpack_public_path__ + "static/media/congrat_hublot.ea989213.png";